import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';
import useLocalePath from '../i18n/useLocalePath';

export default function Header() {
  const { t } = useTranslation();
  const { lp } = useLocalePath();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const headerClass = `sticky top-0 z-50 bg-white transition-all duration-300 ${
    scrolled ? 'shadow-sm border-b-2 border-gray-200' : 'border-b border-transparent'
  }`;

  return (
    <header className={headerClass}>
      <div className="max-w-6xl mx-auto h-16 flex items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to={lp('/')} className="flex items-center">
          <img
            src="/images/logo.svg"
            alt="Nekochan logo"
            className="h-24 w-auto"
            loading="eager"
          />
        </Link>
        <div className="flex items-center gap-4">
          <Link
            to={lp('/blog')}
            className="font-rubik font-medium text-sm text-gray-700 hover:text-brand transition-colors"
          >
            {t('header.blog')}
          </Link>
          <LanguageToggle />
          <Link
            to={lp('/download')}
            className="rounded-full bg-brand text-white font-semibold px-5 py-2 text-sm hover:bg-[#9a2a2d] transition-shadow shadow-md"
          >
            {t('header.download')}
          </Link>
        </div>
      </div>
    </header>
  );
}
